import Chart from "chart.js";

// Set globals, can be overriden by individual charts
Chart.defaults.global.tooltips!.intersect = false;
Chart.defaults.global.tooltips!.mode = "nearest";
Chart.defaults.global.elements!.line!.fill = false;
Chart.defaults.global.animation!.duration = 0;
Chart.defaults.global.elements!.line!.tension = 0;
Chart.defaults.global.elements!.point!.radius = 4;
Chart.defaults.global.elements!.point!.hoverRadius = 4;
Chart.defaults.global.legend!.position = "bottom";

//Remove legend when single data point and reduce blank
// area when there is no legend
Chart.plugins.register({
  id: "awLegendLayout",
  beforeDraw: (chart: any) => {
    if (
      chart.data.datasets.length === 1 &&
      chart.options.scales.yAxes.length === 1
    ) {
      // Single item legend is distracting
      chart.options.legend.display = false;
    }
  }
});

Chart.plugins.register({
  id: "awVisibleData",
  afterDraw: (chart: any) => {
    const noData = Object.values(chart.data.datasets).every((dataSet: any) => {
      return dataSet.data && dataSet.data.length === 0;
    });

    if (noData) {
      const ctx = chart.chart.ctx;
      const width = chart.chart.width;
      const height = chart.chart.height;

      ctx.save();
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "16px normal 'Helvetica Nueue'";
      ctx.fillText("No data to display", width / 2, height / 2);
      ctx.restore();
    }
  }
});
